module.exports = __webpack_public_path__ + "img/-LV54YOiMO9bmwEUz2QZ.933da661.jpg";